import { documentConstants } from "../../constants";

const defaultState = {
  items: [],
  item: {},
  loadingItems: false,
  loadingItem: false,
  fetchedItems: false,
  fetchedItem: false,
  error: null
};

function normalData(arr) {
  if (!Array.isArray(arr)) return []

  return arr.map((elem, index) => Object.assign({}, elem, {
    index: (index + 1),
    whoCreated: elem.whoCreated && typeof elem.whoCreated === 'object' ? elem.whoCreated.firstName + " " + elem.whoCreated.lastName : elem.whoCreated,
    storage: elem.storage && typeof elem.storage === 'object' ? elem.storage.nameStorage : elem.storage,
    complectName: elem.product === null
      ? (elem.nomenclature !== null ? elem.nomenclature.nameNomenclature : "ошибка отображения")
      : (elem.product.nomenclatureComplect?.nameNomenclature + " " + elem.product.serialNumber)
  }))
}

export const complectationReducer = function (state = defaultState, action) {
  switch (action.type) {
    case documentConstants.GETALL_REQUEST_COMPLECTATION:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null
      };
    case documentConstants.GETALL_SUCCESS_COMPLECTATION:
      return {
        ...state,
        items: normalData(action.response),
        loadingItems: false,
        fetchedItems: true,
      };
    case documentConstants.GETALL_FAILURE_COMPLECTATION:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
      };

    case documentConstants.GETBYID_REQUEST_COMPLECTATION:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case documentConstants.GETBYID_SUCCESS_COMPLECTATION:
      const existingItem = state.items.find(item => item.id === action.response.id && item.viewStatus?.status !== action.response?.viewStatus?.status);
      if (existingItem) {
        return {
          ...state,
          items: state.items.map(item => {
            if (item.id !== action.response.id) {
              return item;
            }
            return {
              ...item,
              whoCreated: action.response?.whoCreated ? action.response.whoCreated.firstName + " " + action.response.whoCreated.lastName : item.whoCreated,
              viewStatus: action.response?.viewStatus
            };
          }),
          item: normalData([action.response])[0],
          loadingItem: false,
          fetchedItem: true,
        };
      }
      else {
        return {
          ...state,
          item: normalData([action.response])[0],
          loadingItem: false,
          fetchedItem: true,
        };
      }

    case documentConstants.GETBYID_FAILURE_COMPLECTATION:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.CREATE_REQUEST_COMPLECTATION:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case documentConstants.CREATE_SUCCESS_COMPLECTATION:
      const newItemNormalized = normalData([action.response])[0];
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        items: [...state.items, newItemNormalized],
        item: newItemNormalized,
      };
    case documentConstants.CREATE_FAILURE_COMPLECTATION:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.UPDATE_REQUEST_COMPLECTATION:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case documentConstants.UPDATE_SUCCESS_COMPLECTATION:
      const updatedItemNormalized = normalData([action.response])[0];
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: updatedItemNormalized,
        items: state.items.map((elem) => {
          if (elem.id === action.response.id) return updatedItemNormalized;
          return elem;
        })
      };
    case documentConstants.UPDATE_FAILURE_COMPLECTATION:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.ARCHIVE_REQUEST_COMPLECTATION:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.ARCHIVE_SUCCESS_COMPLECTATION:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: state.items.map((elem) => {
          if (elem.id === action.id) return { ...elem, isArchive: !elem.isArchive, ...action.response };
          return elem;
        })
      };
    case documentConstants.ARCHIVE_FAILURE_COMPLECTATION:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case "RESET_ITEM_COMPLECTATION":
      return {
        ...state,
        fetchedItem: false,
        loadingItem: false,
        item: {}
      }

    case "RESET_ITEMS_COMPLECTATION":
      return {
        ...state,
        fetchedItems: false,
        loadingItems: false,
        items: [],
        error: null
      }
    default:
      return state;
  }
}